<template>
    <div class="flex justify-center pb-3">
        <span class="relative w-1/4">
            <i class="pi pi-search absolute top-2/4 mt-[-6px] left-3 text-surface-400" />
            <InputText v-model="searchText"
                class="py-0 my-1.5 text-center rounded-md border-2 !shadow-none w-full min-w-fit h-6 outline-none"
                placeholder="Search" />
        </span>
    </div>
    <div v-if="params.dataObject.length > 0" class="flex flex-wrap items-center mb-10">
        <div v-for="dataValue of params.dataObject" :key="dataValue[params.objectId]">
            <div v-show="searchText === '' || dataValue[params.objectName].toUpperCase().includes(searchText.toUpperCase())"
                class="flex p-0.25 items-center" style="width:190px;">
                <!-- {{params.dataModel.selectedFilters[params.subcat][params.path]}} -->
                <Checkbox class="border m-1"
                    v-model="params.dataModel.selectedFilters[params.subcat][params.path].selected"
                    :inputId="dataValue[params.objectId]" name=props.header :value="dataValue" />
                <label :for="dataValue[params.objectId]" class="text-a cursor-pointer">{{ dataValue[params.objectName] }}</label>
            </div>
        </div>
    </div>
    <div v-else class="w-full flex pb-6 pt-6">
        <ProgressSpinner class="justify-center w-90 h-90" attrs-color-black strokeWidth="5" animationDuration="1s"
            aria-label="Loading" />
    </div>
    <div class="absolute flex justify-end bottom-1  bg-white" style="width: 94%">
        <button class="bg-[#36a8dd] hover:bg-sky-600 text-white font-bold py-1 px-4 rounded place-content-end my-2"
            @click='onSubmit'>
            Close
        </button>
    </div>
</template>

<script lang='ts' setup>

import { inject, ref, Ref } from "vue";
import Checkbox from 'primevue/checkbox';
import ProgressSpinner from 'primevue/progressspinner';
import InputText from 'primevue/inputtext';
import type { DynamicDialogInstance } from 'primevue/dynamicdialogoptions'

const dialogRef = inject<Ref<DynamicDialogInstance>>('dialogRef')
const params = dialogRef?.value.data;
const searchText = ref("")


function onSubmit() {
    dialogRef?.value.close();
}

</script>
